// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1__cb7cc54681ce593945d7","cls2":"Header-cls2__e6e8e32274ea06292f67 Header-cls1__cb7cc54681ce593945d7"};